module.exports = __webpack_public_path__ + "img/email-action-send-1.e30e7c65.svg";